import AdaLink from 'elements/link/AdaLink'
import { useTranslate } from 'react-admin'

const SystemTemplateTitle = ({ record, translate, style }) => {
  return (
    <span style={style}>
      {translate('Design Template')}: {record ? `"${record.name}"` : ''}
    </span>
  )
}

const Subtitle = () => {
  const translate = useTranslate()
  const hcaLink = 'https://support.opensolar.com/hc/en-us/articles/13782143008015-Modifying-Ada-Auto-Design-templates'

  return (
    <span>
      {translate(
        'Create reusable Auto Design Templates with predefined components, pricing schemes, and system sizing goals. These templates can be used to quickly configure solar systems with consistent settings across projects.'
      )}{' '}
      <AdaLink
        href={hcaLink}
        adaQuestion="How do I create and modify Ada Auto Design templates?"
        linkText={translate('Learn more')}
        showIcon={false}
      />
    </span>
  )
}

export default {
  list: { lazy: () => import('./SystemTemplates'), component: 'SystemTemplateList' },
  edit: { lazy: () => import('./SystemTemplates'), component: 'SystemTemplateEdit' },
  create: { lazy: () => import('./SystemTemplates'), component: 'SystemTemplateCreate' },
  options: {
    create: {
      title: 'Create Auto Design Template',
      subtitle: null,
      breadCrumb: 'Create Auto Design Template',
    },
    list: {
      title: 'My Auto Design Templates',
      subtitle: <Subtitle />,
      breadCrumb: 'Auto Design Templates',
    },
    edit: {
      title: <SystemTemplateTitle />,
      subtitle: null,
      breadCrumb: 'Edit Auto Design Template',
    },
  },
}
